module.exports = __webpack_public_path__ + "static/media/faqTitle.89e32fcf.webp";